var _excluded = ["children", "className", "block", "style", "size", "type", "shape", "triangle", "disabled", "buttonDisabled", "ghost", "needGrouped", "htmlType", "loading", "plain", "onClick", "colorScheme", "variant", "noFocus"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { classnames, isUndefined } from '@okee-uikit/react-utils';
import { useRefCallback } from '@okee-uikit/react-hooks';
import { useDirection, usePrefixCls } from '@okee-uikit/react-config';
import { useWaveAnimation } from '../../hooks/useWaveAnimation';
import LoadingIcon from './LoadingIcon';
export function Button(props) {
  var children = props.children,
      className = props.className,
      _props$block = props.block,
      block = _props$block === void 0 ? false : _props$block,
      _props$style = props.style,
      style = _props$style === void 0 ? {} : _props$style,
      _props$size = props.size,
      size = _props$size === void 0 ? 'md' : _props$size,
      _props$type = props.type,
      type = _props$type === void 0 ? 'default' : _props$type,
      _props$shape = props.shape,
      shape = _props$shape === void 0 ? 'angle' : _props$shape,
      _props$triangle = props.triangle,
      triangle = _props$triangle === void 0 ? false : _props$triangle,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      buttonDisabled = props.buttonDisabled,
      _props$ghost = props.ghost,
      ghost = _props$ghost === void 0 ? false : _props$ghost,
      _props$needGrouped = props.needGrouped,
      needGrouped = _props$needGrouped === void 0 ? true : _props$needGrouped,
      _props$htmlType = props.htmlType,
      htmlType = _props$htmlType === void 0 ? 'button' : _props$htmlType,
      _props$loading = props.loading,
      loading = _props$loading === void 0 ? false : _props$loading,
      _props$plain = props.plain,
      plain = _props$plain === void 0 ? type === 'default' : _props$plain,
      onClick = props.onClick,
      _props$colorScheme = props.colorScheme,
      colorScheme = _props$colorScheme === void 0 ? type : _props$colorScheme,
      variant = props.variant,
      noFocus = props.noFocus,
      extra = _objectWithoutProperties(props, _excluded);

  var rtl = useDirection() === 'rtl';
  var ref = useWaveAnimation({
    disabled: disabled || loading
  });
  var groupedCls = usePrefixCls('can-input-grouped');
  var loadingCls = usePrefixCls('btn-loading');
  var cls = classnames(usePrefixCls('btn', {
    disabled: loading || disabled,
    size: size,
    type: colorScheme,
    shape: shape,
    block: block,
    triangle: triangle,
    ghost: ghost,
    rtl: rtl,
    plain: isUndefined(variant) ? plain : !(variant === null || variant === void 0 ? void 0 : variant.includes('fill')),
    dashed: (variant === null || variant === void 0 ? void 0 : variant.includes('dashed')) || type === 'dashed',
    text: variant === null || variant === void 0 ? void 0 : variant.includes('text'),
    'no-focus': noFocus
  }), needGrouped ? groupedCls : '', loading ? loadingCls : '', className);
  var loadingIconCls = usePrefixCls('btn-loading-icon');
  var clickHandle = useRefCallback(function (event) {
    !loading && !disabled && (onClick === null || onClick === void 0 ? void 0 : onClick(event));
  });
  return React.createElement("button", _objectSpread(_objectSpread({}, extra), {}, {
    ref: ref,
    type: htmlType,
    className: cls,
    disabled: buttonDisabled !== null && buttonDisabled !== void 0 ? buttonDisabled : loading ? true : disabled,
    onClick: clickHandle,
    style: _objectSpread(_objectSpread({}, style), {}, {
      display: style.display ? style.display : block ? 'block' : undefined
    })
  }), !!loading && React.createElement("span", {
    className: loadingIconCls
  }, React.createElement(LoadingIcon, null)), children);
}